/**
 * Tiny action registry.
 *
 * Lets a leaf section trigger a top-level action (defined in main.js) without
 * importing the entry module — which would be a circular import: main.js →
 * sections/summary/summary.js → cart.js → main.js. Vite tolerates that today,
 * but the cycle makes evaluation order load-bearing, so we invert it: main.js
 * registers the implementation, sections call the thin wrapper.
 */

let retryCartFn = null;

/** Called once from main.js init(). */
export function registerRetryCart(fn) {
  retryCartFn = fn;
}

/** Re-run cart hydration. No-op if main.js hasn't registered yet. */
export async function retryCart() {
  if (typeof retryCartFn !== 'function') return;
  await retryCartFn();
}
